const init = () => {
    const searchActiveClass = `header__search-input--active`;
    const searchInput = `js-header-search-input`;
    const searchBtnHandler = () => {
        const searchBtn = `js-header-search-btn`;

        $(`.${searchBtn}`).on('click touch', () => {

            $(`header`).toggleClass(searchActiveClass);
            $(`.${searchInput}`).focus();
            if($(window).width() < 1280){
                $(`.${searchBtn}`).find('i').toggleClass(`ico-search`);
                $(`.${searchBtn}`).find('i').toggleClass(`ico-close`);
            }else $(`.${searchBtn}`).find('i').addClass(`ico-search`);
            
        });
    }

    const searchCloseBtnHandler = () => {
        const closeBtn = `js-header-search-close`;
        $(`.${closeBtn}`).on('click touch', () => $(`header`).toggleClass(searchActiveClass))

    }

    const inputEnterhandler = () => {
        $(document).on('keypress', e => {
            if(e.which == 13 && $(`.${searchInput}`).is(`:focus`)) {
                initiateSearch('/search?keyword=' + $(`.${searchInput}`).val())
            }
        });
    }

    const searchIconhandler = () => {
        const icon = `js-header-search`;
        $(`.${icon}`).on('click touch', ()=> initiateSearch('/search?keyword=' + $(`.${searchInput}`).val()))
    }

    

    const initiateSearch = args => {
        let websitelink = `${window.location.origin}${args}`
        window.location.replace(websitelink);
    }

    searchBtnHandler();
    searchCloseBtnHandler();
    inputEnterhandler();
    searchIconhandler();
}

export const search = {
	init: init
};